<bl-modal-content #content
  [title]="'予約詳細'"
  [footerButtonType]="modalButtonType.Custom">
>
  <div body>
    <table class="table table-bordered">
      <tr>
        <th>
          予約ステータス
        </th>
        <td>
          <div class="form-item">{{ _entity.webReserveStatus }}
            <span class="icon-icon_help" [tooltip]="webReserveStatusForHelp" placement= "bottom" containerClass="tooltip-container">
            </span>
          </div>
        </td>
      </tr>
    </table>
    <section class="panel panel-web-reserve">
      <table class="table table-bordered">
        <tr *ngIf="_organizationName">
          <th>組織名</th>
          <td>
            <div>{{ _organizationName }}</div>
          </td>
        </tr>
        <tr>
          <th>予約番号</th>
          <td>
            <div>{{ _entity.webReserveDispNum }}</div>
          </td>
        </tr>
        <tr>
          <th>サービス</th>
          <td>
            <div>{{ _entity.itemServiceName }}</div>
          </td>
        </tr>
        <tr>
          <th>予約希望日時</th>
          <td>
            <div>{{ _entity.reserveDateStartTime }}</div>
          </td>
        </tr>
        <tr>
          <th>お名前</th>
          <td>
            <div>{{ _entity.customerName }}</div>
          </td>
        </tr>
        <tr>
          <th>フリガナ</th>
          <td>
            <div>{{ _entity.customerNameKana }}</div>
          </td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td>
            <div>{{ _entity.contactTelInformation }}</div>
          </td>
        </tr>
        <tr>
          <th>メールアドレス</th>
          <td>
            <a [href]="_mailto">{{ _entity.contactEmailInformation }}</a>
          </td>
        </tr>
        <tr>
          <th>住所</th>
          <td>
            <div>{{ _entity.address }}</div>
          </td>
        </tr>
        <tr>
          <th>電話連絡可能な時間帯	</th>
          <td>
            <div>{{ _entity.contactEnableTime }}</div>
          </td>
        </tr>
        <tr>
          <th>お車のナンバー</th>
          <td>
            <div>{{ _entity.registrateNum }}</div>
          </td>
        </tr>
        <tr>
          <th>メーカー</th>
          <td>
            <div>{{ _entity.blVehicleMakerFullWFixNm }}</div>
          </td>
        </tr>
        <tr>
          <th>車種</th>
          <td>
            <div>{{ _entity.vehicleModelFixFullWName }}</div>
          </td>
        </tr>
        <tr>
          <th>車検満了日</th>
          <td>
            <div>{{ _entity.vehicleInspectionExpirationDate }}</div>
          </td>
        </tr>
        <tr>
          <th>代車</th>
          <td>
            <div>{{ _entity.replacementVehicle }}</div>
          </td>
        </tr>
        <tr *ngIf="_isValidCouponManage">
          <th>クーポンコード</th>
          <td>
            <div>{{ _entity.ticketCode }}</div>
          </td>
        </tr>
        <tr *ngIf="_isValidCouponManage">
          <th>クーポン名</th>
          <td>
            <div>{{ _entity.ticketName }}</div>
          </td>
        </tr>
        <tr *ngIf="_isValidCouponManage">
          <th>紹介コード</th>
          <td>
            <div>{{ _entity.introducerCode }}</div>
          </td>
        </tr>
        <tr *ngIf="_isValidCouponManage">
          <th>紹介者名</th>
          <td>
            <div>{{ _entity.introducerName }}</div>
          </td>
        </tr>
        <tr *ngIf="_isValidCouponManage">
          <th>紹介者名フリガナ</th>
          <td>
            <div>{{ _entity.introducerNameKana }}</div>
          </td>
        </tr>
        <tr *ngIf="_isValidCouponManage">
          <th>紹介者の顧客情報</th>
          <td>
            <div *ngIf="_entity.customerCode !== 0">
              顧客コード　　：{{ _entity.customerCode }}
            </div>
            <div *ngIf="_entity.customerName1 !== '' || _entity.customerNameKana1 !== ''">
              顧客名（カナ）：{{ _entity.customerName1 }}（{{ _entity.customerNameKana1 }}）
            </div>
          </td>
        </tr>
        <tr>
          <th>ご質問・ご希望など（備考）</th>
          <td>
            <div>{{ _entity.note }}</div>
          </td>
        </tr>
        <tr *ngIf="_cancelOnly">
          <th>キャンセル日</th>
          <td>
            <div>{{ _entity.cancelDate }}</div>
          </td>
        </tr>
        <tr *ngIf="_cancelOnly">
          <th>キャンセル理由</th>
          <td>
            <div>{{ _entity.cancelReason }}</div>
          </td>
        </tr>
      </table>
    </section>
  </div>
  <div footer>
    <button class="btn btn-success" type="button"
        (click)="content.done()">閉じる
    </button>
  </div>
  <ng-template #webReserveStatusForHelp>
    <table class="tooltip-table">
      <tbody>
        <tr *ngIf="_webReserveStatus === WebReserveStatus.Accepted">
          <th>予約受付</th>
          <td>お客様がWeb予約ページで予約し、予約が未確定の状態です。<br>
            予約が未確定の間は、お客様がWeb予約ページで予約取消の操作が可能です。
          </td>
        </tr>
        <tr *ngIf="_webReserveStatus === WebReserveStatus.AcceptedCancel">
          <th>予約受付取消</th>
          <td>予約受付を、お客様または店舗側で取消した状態です。<br>
            一度取消した予約は元に戻すことはできません。
          </td>
        </tr>
        <tr *ngIf="_webReserveStatus === WebReserveStatus.Confirmed">
          <th>予約確定</th>
          <td>予約が確定し、受付内容を作成した状態です。<br>
            予約が確定すると、お客様はWeb予約ページで予約取消の操作ができなくなります。
          </td>
        </tr>
        <tr *ngIf="_webReserveStatus === WebReserveStatus.ConfirmedCancel">
          <th>予約確定取消</th>
          <td>予約確定後に、予約取消または受付中止の操作を行った状態です。<br>
            受付画面から受付再開を行うことで、予約確定に戻すことができます。
          </td>
        </tr>
      </tbody>
    </table>
  </ng-template>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/web-reserve-detail/web-reserve-detail.component.html